import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { APP_VERSION, needsRefresh, forceRefresh } from '@/lib/version';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function VersionChecker() {
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);

  useEffect(() => {
    // Check if user has an old cached version
    if (needsRefresh()) {
      setShowUpdateBanner(true);
      
      // Show toast notification
      toast.info('Ny version tilgængelig', {
        description: 'Klik for at opdatere til den nyeste version',
        action: {
          label: 'Opdater nu',
          onClick: () => forceRefresh(),
        },
        duration: 10000,
      });
    }

    // Add keyboard shortcut for force refresh (Ctrl+Shift+R)
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'R') {
        e.preventDefault();
        forceRefresh();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (!showUpdateBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 bg-primary text-primary-foreground px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 animate-in slide-in-from-left">
      <RefreshCw className="w-5 h-5" />
      <div className="flex flex-col">
        <span className="font-medium text-sm">Ny version tilgængelig</span>
        <span className="text-xs opacity-80">v{APP_VERSION}</span>
      </div>
      <Button 
        size="sm" 
        variant="secondary"
        onClick={() => forceRefresh()}
        className="ml-2"
      >
        Opdater
      </Button>
    </div>
  );
}
